import { ClusterCenter } from "../types";

/** A cluster center with every metric the diamond marker needs to be drawn. */
export type PlottableClusterCenter = ClusterCenter & {
  volume: number;
  difficulty: number;
  ranking: number;
};

/**
 * Whether the cluster-center diamond is drawn: it needs a position (difficulty, volume) and a size (ranking). 
 * Every place that shows the center alongside the chart (legends, downloaded legend, center table row) must use this so they never disagree about whether the diamond exists.
 */
export const isCenterPlottable = (
  center: ClusterCenter | null | undefined,
): center is PlottableClusterCenter =>
  !!center &&
  center.difficulty != null &&
  center.volume != null &&
  center.ranking != null;
